module.exports = __webpack_public_path__ + "static/media/assured-periodic.101f7384.png";